import { acceptHMRUpdate, defineStore } from 'pinia';
import { useApi } from '@/composables/use-api.ts';
import { ApprovalApplicationWithEmployeeDocumentLineDto } from '@/services/api/approval-api.ts';

export const ApprovalStatusMap = {
  REQUEST: '요청',
  DONE: '완료',
  REJECT: '반려',
  CANCEL: '관리자 취소',
};

interface State {
  myPendingApprovalApplications: ApprovalApplicationWithEmployeeDocumentLineDto[];
  myConfirmApprovalApplications: ApprovalApplicationWithEmployeeDocumentLineDto[];
}

export const useApprovalStore = defineStore('approval', {
  state: (): State => {
    return {
      myPendingApprovalApplications: [],
      myConfirmApprovalApplications: [],
    };
  },
  actions: {
    async getMyPendingApprovalApplications() {
      const { approval } = useApi();

      return (this.myPendingApprovalApplications =
        await approval.listByPendingAsync());
    },

    getMyPendingApprovalApplication(applicationId: number) {
      return this.myPendingApprovalApplications.find(
        (item) => item.id === applicationId
      );
    },

    async getMyConfirmApprovalApplications(startDt: string, endDt: string) {
      const { approval } = useApi();
      return (this.myConfirmApprovalApplications =
        await approval.listByConfirmAsync(startDt, endDt));
    },

    getMyConfirmApprovalApplication(applicationId: number) {
      return this.myConfirmApprovalApplications.find(
        (item) => item.id === applicationId
      );
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useApprovalStore, import.meta.hot));
}
